<template>
  <div kv :class="type">
    <h2>{{ title }}</h2>
  </div>
</template>

<style lang="less">
 @import "../../../less/vars";
@import "../../../less/asset";

  [kv] { .h(320); .no-repeat;
    &.join { .bg('@{common}/kv-join.png'); .cover; .bg-c; }
    &.complaint { .bg('@{common}/kv-complaint.png'); .cover; .bg-c; }
    &.my { .bg('@{common}/kv-my.png'); .cover; .bg-c; }
    &.cs { .bg('@{common}/kv-cs.png'); .cover; .bg-c; }
    &.cert { .bg('@{common}/kv-cert.png'); .cover; .bg-c; }
    &.anew { .bg('@{common}/kv-anew.png'); .cover; .bg-c; }

    h2 { .pt(170); .fs(56, 1); .tc; color: #fff; }
  }
</style>

<script>
export default {
  name: 'KeyVisual',
  props: {
    type: { type: String, default: null },
    title: { type: String, default: null },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/component/KeyVisual.vue